import styled from 'styled-components';

export const Container = styled.div`
  padding: 0;
  box-shadow: none;
  background-color: transparent;
  margin: 0 ${({ theme }) => theme.spacing.ms} ${({ theme }) => theme.spacing.md};
`;

export const NoDataMessage = styled.div`
  background: ${({ theme }) => theme.colors.background};
  margin: 0 ${({ theme }) => theme.spacing.ms} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => theme.spacing.md};
  box-shadow: ${({ theme }) => theme.shadows.md};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.colors.text.primary};
`;
